import React from 'react';
import { motion } from 'framer-motion';
import { Coins } from '@phosphor-icons/react';

/**
 * Animated overlay banner that appears when a viewer tips during a live stream.
 */
const TipAlert = ({ name, amount }) => (
  <motion.div
    initial={{ opacity: 0, y: -20, scale: 0.9 }}
    animate={{ opacity: 1, y: 0, scale: 1 }}
    exit={{ opacity: 0, y: -20 }}
    className="absolute top-16 left-1/2 -translate-x-1/2 z-30 px-6 py-3 bg-gradient-to-r from-amber-500 to-blue-500 rounded-full shadow-2xl flex items-center gap-2"
  >
    <Coins weight="fill" className="w-5 h-5 text-white" />
    <span className="text-white font-bold">{name} tipped {amount} tokens!</span>
  </motion.div>
);

export default TipAlert;
